import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5002';
const API_URL = `${API_BASE_URL}/api/v1`;

export const getProjectResources = async (projectId) => {
  try {
    const response = await axios.get(`${API_URL}/resources/${projectId}`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createResource = async (projectId, resourceData) => {
  try {
    console.log('Creating resource with data:', JSON.stringify(resourceData));
    console.log('Project ID:', projectId);
    
    // Create a minimal resource object with only the essential fields
    const essentialData = {
      name: resourceData.name || '',
      type: resourceData.type || '',
      status: resourceData.status || 'pending_approval',
      startDate: resourceData.startDate || new Date().toISOString().split('T')[0],
      endDate: resourceData.endDate || new Date().toISOString().split('T')[0],
      projectId: projectId
    };
    
    // Add optional fields if they exist
    if (resourceData.subtype) essentialData.subtype = resourceData.subtype;
    if (resourceData.notes) essentialData.notes = resourceData.notes;
    if (resourceData.location) essentialData.location = resourceData.location;
    
    console.log('Simplified request data:', JSON.stringify(essentialData));
    console.log('API URL:', `${API_URL}/resources/${projectId}`);
    
    const response = await axios.post(`${API_URL}/resources/${projectId}`, essentialData, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
      }
    });
    
    console.log('Resource created successfully:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error details:', error?.response?.data || error?.message || 'Unknown error');
    if (error?.response) {
      console.error('Response status:', error.response.status);
      console.error('Response headers:', error.response.headers);
      console.error('Response data:', error.response.data);
    }
    throw error;
  }
};

export const updateResource = async (projectId, resourceId, resourceData) => {
  try {
    console.log('Updating resource with data:', JSON.stringify(resourceData));
    console.log('Project ID:', projectId, 'Resource ID:', resourceId);
    
    // Create a minimal resource object with only the essential fields
    const essentialData = {
      name: resourceData.name || '',
      type: resourceData.type || '',
      status: resourceData.status || 'pending_approval',
      startDate: resourceData.startDate || new Date().toISOString().split('T')[0],
      endDate: resourceData.endDate || new Date().toISOString().split('T')[0],
      projectId: projectId
    };
    
    // Add optional fields if they exist
    if (resourceData.subtype) essentialData.subtype = resourceData.subtype;
    if (resourceData.notes) essentialData.notes = resourceData.notes;
    if (resourceData.location) essentialData.location = resourceData.location;
    
    console.log('Simplified request data:', JSON.stringify(essentialData));
    console.log('API URL:', `${API_URL}/resources/${projectId}/${resourceId}`);
    
    const response = await axios.put(`${API_URL}/resources/${projectId}/${resourceId}`, essentialData, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
      }
    });
    
    console.log('Resource updated successfully:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error details:', error?.response?.data || error?.message || 'Unknown error');
    if (error?.response) {
      console.error('Response status:', error.response.status);
      console.error('Response headers:', error.response.headers);
      console.error('Response data:', error.response.data);
    }
    throw error;
  }
};

export const deleteResource = async (projectId, resourceId) => {
  try {
    const response = await axios.delete(`${API_URL}/resources/${projectId}/${resourceId}`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
